import React from 'react';

interface PropsIndicadorCarregamento {
  /** Mensagem opcional exibida abaixo do spinner */
  mensagem?: string;
  /** Tamanho do spinner: 'pequeno' | 'medio' | 'grande' */
  tamanho?: 'pequeno' | 'medio' | 'grande';
}

/**
 * Indicador de carregamento (loading spinner).
 * Requisitos: 5
 *
 * - Exibe spinner animado durante carregamento de dados
 * - Mensagem opcional para contexto
 * - Tamanhos configuráveis
 * - Acessível com role="status" e aria-live
 */
const IndicadorCarregamento: React.FC<PropsIndicadorCarregamento> = ({
  mensagem = 'Carregando...',
  tamanho = 'medio',
}) => {
  const tamanhoClasse = `indicador-carregamento--${tamanho}`;

  return (
    <div
      className={`indicador-carregamento ${tamanhoClasse}`}
      role="status"
      aria-live="polite"
      aria-label={mensagem}
    >
      <div className="indicador-carregamento__spinner" aria-hidden="true">
        <svg
          className="indicador-carregamento__svg"
          viewBox="0 0 50 50"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="indicador-carregamento__circulo"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="4"
          />
        </svg>
      </div>
      {mensagem && (
        <p className="indicador-carregamento__mensagem">{mensagem}</p>
      )}
    </div>
  );
};

export default IndicadorCarregamento;
